import { createContext, useContext, useMemo } from 'react';

const PortfolioDashboardContext = createContext(null);

/** @param {{ period: import('./portfolioDashboard.types').PortfolioPeriod, children: import('react').ReactNode }} props */
export const PortfolioDashboardProvider = function PortfolioDashboardProvider({ period, children }) {
    const value = useMemo(() => ({ period }), [period]);

    return (
        <PortfolioDashboardContext.Provider value={value}>
            {children}
        </PortfolioDashboardContext.Provider>
    );
};

/** @returns {{ period: import('./portfolioDashboard.types').PortfolioPeriod }} */
export function usePortfolioDashboard() {
    return useContext(PortfolioDashboardContext);
}
